// Which reading of the recipe catalogue a page is asking for — as a URL, as a
// request, and as a cache key.
//
// Pure, and its own module, because those three have to agree. Every other
// recipe control is free: the buy/craft toggle picks between two totals that
// already rode in one response, so it is a render. `scrolls` is not — it
// changes which ingredients the totals are summed from, and shipping both
// readings would mean four totals and four coverage counts on every row. So it
// costs a request, and a react-query key that forgot it would hand one
// reading's numbers to the other's checkbox.

/** The query string's value for "do not count the scroll". The default — count
 *  it, which is what this server does — is an absent key, the way `mode`,
 *  `sort` and `q` spell theirs: a link carries only what departs from the
 *  view a reader would get by following it cold.
 *
 *  The page's URL and the API's parameter use the same spelling on purpose, so
 *  a reader looking at one and a request log showing the other do not need a
 *  translation table between them. */
export const SCROLLS_OFF = "0";

/** Read the checkbox's state out of the page's query string. */
export function countsScrolls(params: URLSearchParams): boolean {
  return params.get("scrolls") !== SCROLLS_OFF;
}

export interface RecipeQuery {
  /** react-query's cache key. Carries the reading, so the two cache
   *  independently and switching back is instant rather than a refetch. */
  queryKey: (string | number | boolean)[];
  path: string;
}

function suffix(countScrolls: boolean): string {
  return countScrolls ? "" : `?scrolls=${SCROLLS_OFF}`;
}

export function recipesQuery(countScrolls: boolean): RecipeQuery {
  return { queryKey: ["recipes", countScrolls], path: `/recipes${suffix(countScrolls)}` };
}

export function recipeQuery(recipeId: number, countScrolls: boolean): RecipeQuery {
  return {
    queryKey: ["recipe", recipeId, countScrolls],
    path: `/recipes/${recipeId}${suffix(countScrolls)}`,
  };
}
